<script>
import { loginPagePath } from '@/utils/loginFlow'
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { Picture, ChatDotRound, Star, StarFilled, Delete  } from '@element-plus/icons-vue'
import { ElMessageBox } from 'element-plus'
import ImageBar from './components/ImageBar.vue'
import axios from 'axios'
import { resolveProfilePhotoUrl } from '@/utils/photoUpload'

export default {
  name: 'MomentView',
  components: {
    Picture,
    ChatDotRound,
    Star,
    StarFilled,
    
    Delete,
  
    ImageBar
  },
  setup() {
    const posts = ref([])
    const loading = ref(false)
    const hasMore = ref(true)
    const minId = ref(0)
    const observer = ref(null)
    const loadMoreTrigger = ref(null)
   
    const currentUuid = ref(null)
    const commentContent = ref('')
    const showCommentInput = ref(false)
    const currentMomentId = ref(null)
    const replyToComment = ref(null)

    const handleLike = async (momentId, isLiked) => {
      try {
        const token = localStorage.getItem('jwt_token')
        if (!token) {
          console.log('No token found! User needs to login to like posts.')
          // 可以在这里添加一个提示，告诉用户需要登录才能点赞
          return
        }

        const response = await axios.post('/api/v1/moment/' + (isLiked ? 'unlike' : 'like'), {
          momentId: momentId
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        if (response.data.code === 200) {
          const post = posts.value.find(p => p.id === momentId)
          if (post) {
            post.likes = response.data.data.likeCount
            post.isLiked = !isLiked
            // Update the likes list
            try {
              post.likesList = JSON.parse(response.data.data.likes)
            } catch (e) {
              console.error('Error parsing likes:', e)
              post.likesList = []
            }
          }
        }
      } catch (error) {
        console.error('Error handling like:', error)
        if (error.response && error.response.status === 401) {
       
          window.location.href = loginPagePath(window.location.pathname + window.location.search)
        }
      }
    }

    const isPostLikedByCurrentUser = (post) => {
      if (!post.likesList) return false
      return post.likesList.some(like => like.uuid === currentUuid.value)
    }

    const isLoggedIn = () => {
      return !!localStorage.getItem('jwt_token')
    }

    const setupObserver = () => {
      // 先断开之前的观察者
      if (observer.value) {
        observer.value.disconnect()
        observer.value = null
      }

      // 等待 DOM 更新完成
      nextTick(() => {
        if (!loadMoreTrigger.value) {
          console.warn('loadMoreTrigger is not available')
          return
        }

        // 创建新的观察者
        observer.value = new IntersectionObserver((entries) => {
          const isIntersecting = entries[0].isIntersecting
          console.log('IntersectionObserver triggered:', { 
            isIntersecting,
            loading: loading.value,
            hasMore: hasMore.value,
            minId: minId.value
          })
          
          if (isIntersecting && !loading.value && hasMore.value) {
            console.log('Triggering load more...')
            fetchMoments(true)
          }
        }, {
          root: null,
          rootMargin: '100px',
          threshold: 0.1
        })

        console.log('Starting to observe loadMoreTrigger')
        observer.value.observe(loadMoreTrigger.value)
      })
    }

    const fetchMoments = async (isLoadMore = false) => {
      if (loading.value || (!isLoadMore && !hasMore.value)) {
        console.log('Skip loading:', { loading: loading.value, isLoadMore, hasMore: hasMore.value })
        return
      }
      
      try {
        loading.value = true
        const token = localStorage.getItem('jwt_token')
        const isLoggedIn = !!token

        // console.log('Fetching moments:', { isLoadMore, fromId: isLoadMore ? minId.value : 0 })

        const endpoint = isLoggedIn ? '/api/v1/moment/list' : '/api/v1/moment/guest/list'
        const headers = isLoggedIn ? {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        } : {
          'Content-Type': 'application/json'
        }

        const response = await axios.post(endpoint, {
          fromId: isLoadMore ? minId.value : 0
        }, { headers })

        if (response.data.code === 200) {
          if (response.data.data.moments != null) {
            
          const newMoments = response.data.data.moments.map(moment => {
            // 处理图片URL
            let images = []
            if (moment.images && moment.images.length > 0) {
              images = moment.images
                .filter(img => img && String(img).trim() !== '')
                .map(img => `/api/v1/${img}`)
            }

            // 处理评论数据
            let comments = []
            if (moment.comments) {
              try {
                comments = JSON.parse(moment.comments)
              } catch (e) {
                console.error('Error parsing comments:', e)
              }
            }

            let likesList = []
            if (moment.likes) {
              try {
                likesList = JSON.parse(moment.likes)
              } catch (e) {
                console.error('Error parsing likes:', e)
              }
            }

            return {
              id: moment.momentId,
              uuid: moment.user.uuid,
              user: {
                name: moment.nickName,
                avatar: resolveProfilePhotoUrl(moment.avatar),
                birthyear: moment.user.birthyear,
                city: moment.user.city,
                occupation: moment.user.occupation,
                education: moment.user.education,
                sex: moment.user.sex,
                height: moment.user.height
              },
              content: moment.content,
              images: images,
              likes: moment.likeCount,
              isLiked: moment.isLiked || false,
              likesList: likesList,
              commentCount: moment.commentCount,
              timestamp: new Date(moment.createdAt * 1000).toLocaleString(),
              comments: comments,
              blocked: Number(moment.state) === 0
            }
          })

          // console.log('Received moments:', { 
          //   count: newMoments.length, 
          //   minId: newMoments.length > 0 ? Math.min(...newMoments.map(m => m.id)) : 'none',
          //   isLoadMore 
          // })
        

          if (isLoadMore) {
            posts.value = [...posts.value, ...newMoments]
          } else {
            posts.value = newMoments
          }

          // 更新最小ID
          if (newMoments.length > 0) {
            minId.value = Math.min(...newMoments.map(m => m.id))
            console.log('Next load will use fromId:', minId.value)
          }
          console.log('newMoments.length:', newMoments.length)

          // 检查是否还有更多数据
          hasMore.value = newMoments.length > 0
          if (minId.value === 1) {
            //hasMore.value = false
          }
          console.log('Updated state:', { 
            totalPosts: posts.value.length, 
            minId: minId.value, 
            hasMore: hasMore.value,
            nextFromId: minId.value
          })

        } else {
          hasMore.value = false
        }

          // 在数据更新后重新设置观察者
          setupObserver()
        }
      } catch (error) {
        console.error('Error fetching moments:', error)
        if (error.response && error.response.status === 401) {
         
          window.location.href = loginPagePath(window.location.pathname + window.location.search)
        }
      } finally {
        loading.value = false
      }
    }

    const deleteMoment = async (momentId) => {
      try {
        await ElMessageBox.confirm(
          '确定要删除这条动态吗？',
          '删除确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )

        const token = localStorage.getItem('jwt_token')
        if (!token) {
          console.log('No token found! User needs to login to delete posts.')
          return
        }

        const response = await axios.post('/api/v1/moment/delete', {
          momentId: momentId
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        if (response.data.code === 200) {
          // Remove the deleted moment from the posts array
          posts.value = posts.value.filter(post => post.id !== momentId)
        }
      } catch (error) {
        if (error === 'cancel') {
          // User cancelled the deletion
          return
        }
        console.error('Error deleting moment:', error)
        if (error.response && error.response.status === 401) {
         
          window.location.href = loginPagePath(window.location.pathname + window.location.search)
        }
      }
    }

    const toggleCommentInput = (momentId, comment = null) => {
      const token = localStorage.getItem('jwt_token')
      if (!token) {
        // 如果未登录，直接显示评论输入框，但会显示登录提示
        currentMomentId.value = momentId
        showCommentInput.value = !showCommentInput.value
        if (comment) {
          replyToComment.value = {
            CommentId: comment.CommentId,
            Nickname: comment.Nickname
          }
        } else {
          replyToComment.value = null
        }
        if (!showCommentInput.value) {
          commentContent.value = ''
          replyToComment.value = null
        }
        return
      }

      currentMomentId.value = momentId
      showCommentInput.value = !showCommentInput.value
      if (comment) {
        replyToComment.value = {
          CommentId: comment.CommentId,
          Nickname: comment.Nickname
        }
      } else {
        replyToComment.value = null
      }
      if (!showCommentInput.value) {
        commentContent.value = ''
        replyToComment.value = null
      }
    }

    const createComment = async (momentId) => {
      try {
        const token = localStorage.getItem('jwt_token')
        if (!token) {
          console.log('No token found! User needs to login to comment.')
          return
        }

        const response = await axios.post('/api/v1/comment/create', {
          momentId: momentId,
          content: commentContent.value,
          parentId: replyToComment.value ? replyToComment.value.CommentId : 0
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        if (response.data.code === 200) {
          const post = posts.value.find(p => p.id === momentId)
          if (post) {
            post.commentCount++
            const comments = JSON.parse(response.data.data.comments)
            if (!post.comments) {
              post.comments = []
            }
            post.comments = comments
          }
          commentContent.value = ''
          showCommentInput.value = false
          replyToComment.value = null
        }
      } catch (error) {
        console.error('Error creating comment:', error)
        if (error.response && error.response.status === 401) {
         
          window.location.href = loginPagePath(window.location.pathname + window.location.search)
        }
      }
    }

    const deleteComment = async (momentId, commentId) => {
      try {
        const token = localStorage.getItem('jwt_token')
        if (!token) {
          console.log('No token found! User needs to login to delete comments.')
          return
        }

        const response = await axios.post('/api/v1/comment/delete', {
          commentId: commentId
        }, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        if (response.data.code === 200) {
          const post = posts.value.find(p => p.id === momentId)
          if (post) {
            // Update comment count from API response
            post.commentCount = response.data.data.count
            // Update comments list from API response
            const comments = JSON.parse(response.data.data.comments)
            post.comments = comments
          }
        }
      } catch (error) {
        console.error('Error deleting comment:', error)
        if (error.response && error.response.status === 401) {
           
          window.location.href = loginPagePath(window.location.pathname + window.location.search)
        }
      }
    }

    onMounted(async () => {
      // Get current user ID from localStorage or your auth system
      const userInfo = JSON.parse(localStorage.getItem('user_info') || '{}')
     
      currentUuid.value = userInfo.uuid
      
      console.log('currentUuid:', currentUuid.value)
      await fetchMoments()
      setupObserver()
    })

    onUnmounted(() => {
      if (observer.value) {
        observer.value.disconnect()
        observer.value = null
      }
    })

          return {
        posts,
        loading,
        hasMore,
        loadMoreTrigger,
     
        currentUuid,
        deleteMoment,
        commentContent,
        showCommentInput,
        currentMomentId,
        replyToComment,
        createComment,
        deleteComment,
        toggleCommentInput,
        handleLike,
        isPostLikedByCurrentUser,
        isLoggedIn
      }
  }
}
</script>

<template>
  <ImageBar 
    title="时刻"
    imageUrl="https://picsum.photos/1200/500?random=1"
    height="80px"
  />
  
  <div class="moment-view">
    
    
  
    <div class="container">
      <div class="create-moment">
        <router-link v-if="isLoggedIn()" to="/moment/create">
          <el-link type="primary">今天怎么样? 有什么开心的事情可以分享?</el-link>
        </router-link>
        <router-link v-else to="/login">
          <el-link type="primary">登录后发布动态</el-link>
        </router-link>
      </div>
      <div v-if="loading && posts.length === 0" class="loading-container">
        <el-skeleton :rows="3" animated />
      </div>
      <div v-else-if="posts.length === 0" class="empty-state">
        <el-empty description="暂无动态" />
      </div>
      <div v-else class="feed">
        <div v-for="post in posts" :key="post.id" class="post-card">
          <div class="post-header">
            <el-avatar :size="40" :src="post.user.avatar" class="user-avatar">
              {{ post.user.name?.charAt(0) || '?' }}
            </el-avatar>
            <div class="user-info">
              <h3>
                {{ post.user.name }}
                <el-tag v-if="post.blocked" type="danger" size="small">已屏蔽</el-tag>
              </h3>
              <div class="user-meta">
                <span class="user-tag gender-tag">
                  <span :class="post.user.sex === 1 ? 'male-icon' : 'female-icon'">
                    {{ post.user.sex === 1 ? '♂' : '♀' }}
                  </span>
                </span>
                <span class="user-tag" v-if="post.user.height">{{ post.user.height }}cm</span>
                <span class="user-tag" v-if="post.user.birthyear">{{ post.user.birthyear }}年</span>
                <span class="user-tag" v-if="post.user.city">{{ post.user.city }}</span>
                <span class="user-tag" v-if="post.user.occupation">{{ post.user.occupation }}</span>
                <span class="user-tag" v-if="post.user.education">{{ post.user.education }}</span>
                <span class="timestamp">{{ post.timestamp }}</span>
              </div>
            </div>
          </div>
          
          <div class="post-content">
            <p>{{ post.content }}</p>
            <div v-if="post.images && post.images.length > 0" class="post-images" :class="{
              'single-image': post.images.length === 1,
              'two-by-two': post.images.length > 1 && post.images.length <= 4,
              'three-by-three': post.images.length > 4
            }">
              <el-image 
                v-for="(image, index) in post.images" 
                :key="index"
                :src="image" 
                fit="cover"
                class="post-image"
                :preview-src-list="post.images"
              >
                <template #error>
                  <div class="image-slot">
                    <el-icon><Picture /></el-icon>
                  </div>
                </template>
              </el-image>
            </div>
          </div>
          
          <div class="post-actions">
            <button class="action-btn" :class="{ 'liked': isPostLikedByCurrentUser(post) }" @click="handleLike(post.id, isPostLikedByCurrentUser(post))">
              <el-tooltip
                :content="post.likesList ? post.likesList.map(like => like.nickname).join(', ') : ''"
                placement="top"
                :disabled="!post.likesList || post.likesList.length === 0"
              >
                <div class="like-button-content">
                  <el-icon><component :is="isPostLikedByCurrentUser(post) ? 'StarFilled' : 'Star'" /></el-icon>
                  <span>{{ post.likes }}</span>
                </div>
              </el-tooltip>
            </button>
            <button class="action-btn" @click="toggleCommentInput(post.id)">
              <el-icon><ChatDotRound /></el-icon>
              <span>{{ post.commentCount }}</span>
            </button>
            <!-- <button class="action-btn">
              <el-icon><Share /></el-icon>
              <span>Share</span>
            </button> -->
            <button v-if="currentUuid === post.uuid" 
                    class="action-btn delete-btn"
                    @click="deleteMoment(post.id)">
              <el-icon><Delete /></el-icon>
              <span>删除</span>
            </button>
          </div>

          <!-- Likes List -->
          <div class="likes-list" v-if="post.likesList && post.likesList.length > 0">
            <div class="likes-header">
              
              
            </div>
            <div class="likes-content"><el-icon><StarFilled /></el-icon>
              <span v-for="(like, index) in post.likesList" :key="like.uuid" class="liker-name">
                {{ like.nickname }}{{ index < post.likesList.length - 1 ? '、' : '' }}
              </span>
            </div>
          </div>

          <!-- Comment Section -->
          <div class="comment-section" v-if="showCommentInput && currentMomentId === post.id">
            <div v-if="!isLoggedIn()" class="login-prompt">
              <p>请先登录后再发表评论</p>
              <router-link to="/login">
                <el-button type="primary" size="small">去登录</el-button>
              </router-link>
            </div>
            <div v-else class="comment-input">
              <el-input
                v-model="commentContent"
                type="textarea"
                :rows="2"
                :placeholder="replyToComment ? `回复 ${replyToComment.Nickname}：` : '写下你的评论...'"
              />
              <div class="comment-actions">
                <el-button type="primary" size="small" @click="createComment(post.id)">发送</el-button>
                <el-button size="small" @click="toggleCommentInput(post.id)">取消</el-button>
              </div>
            </div>
          </div>

          <!-- Comments List -->
          <div class="comments-list" v-if="post.comments && post.comments.length > 0">
            <div v-for="comment in post.comments" :key="comment.CommentId" class="comment-item">
              <div class="comment-content">
                <div class="comment-header">
                  <div class="comment-info">
                    <span class="comment-author">{{ comment.Nickname }}</span>
                    <span class="comment-text">{{ comment.Content }}</span>
                  </div>
                  <div class="comment-actions">
                    <el-button type="text" size="small" @click="toggleCommentInput(post.id, comment)">回复</el-button>
                    <el-button 
                      v-if="currentUuid === comment.Uuid"
                      type="text" 
                      size="small" 
                      class="delete-btn"
                      @click="deleteComment(post.id, comment.CommentId)"
                    >删除</el-button>
                  </div>
                </div>
                <div v-if="comment.ParentId > 0" class="reply-info">
                  回复 {{ comment.ParentNickname }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="loading && posts.length > 0" class="loading-more">
          <el-skeleton :rows="1" animated />
        </div>
        <div v-else-if="!hasMore" class="no-more">
          没有更多动态了
        </div>
        <div v-else ref="loadMoreTrigger" class="load-more-trigger"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.moment-view {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.container {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
   
}

h2 {
  color: var(--el-text-color-primary);
  margin-bottom: 20px;
  font-size: 24px;
}

.feed {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.post-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.post-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}

.user-info {
  flex: 1;
}

.user-info h3 {
  margin: 0;
  font-size: 16px;
  color: var(--el-text-color-primary);
}

.user-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
}

.user-tag {
  font-size: 12px;
  color: var(--el-text-color-secondary);
  background-color: var(--el-fill-color-light);
  padding: 2px 8px;
  border-radius: 4px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
}

.gender-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  font-size: 16px;
  font-weight: bold;
}

.male-icon {
  color: #409EFF;
}

.female-icon {
  color: #F56C6C;
}

.timestamp {
  font-size: 12px;
  color: var(--el-text-color-secondary);
  margin-left: auto;
}

.post-content {
  margin-bottom: 15px;
}

.post-content p {
  margin: 0 0 15px 0;
  color: var(--el-text-color-regular);
  line-height: 1.5;
}

.post-images {
  margin-top: 10px;
  display: grid;
  gap: 4px;
}

.post-images.single-image {
  grid-template-columns: 1fr;
}

.post-images.two-by-two {
  grid-template-columns: repeat(2, 1fr);
}

.post-images.three-by-three {
  grid-template-columns: repeat(3, 1fr);
}

.post-image {
  width: 100%;
  aspect-ratio: 1;
  border-radius: 8px;
  cursor: pointer;
  object-fit: cover;
}

.post-actions {
  display: flex;
  gap: 15px;
  border-top: 1px solid var(--el-border-color-light);
  padding-top: 15px;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  color: var(--el-text-color-secondary);
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 4px;
  transition: all 0.3s;
}

.action-btn:hover {
  background-color: var(--el-fill-color-light);
  color: var(--el-color-primary);
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  aspect-ratio: 1;
  background: var(--el-fill-color-light);
  color: var(--el-text-color-secondary);
  font-size: 30px;
  border-radius: 8px;
}

.loading-container {
  padding: 20px;
}

.loading-more {
  padding: 20px;
  text-align: center;
}

.no-more {
  text-align: center;
  padding: 20px;
  color: var(--el-text-color-secondary);
}

.load-more-trigger {
  height: 1px;
  width: 100%;
}

.action-btn.delete-btn:hover {
  background-color: var(--el-color-danger-light-9);
  color: var(--el-color-danger);
}

.action-btn.liked {
  color: var(--el-color-primary);
}

.action-btn.liked .el-icon {
  color: var(--el-color-primary);
}

.comment-section {
  margin-top: 15px;
  padding: 15px;
  background-color: var(--el-fill-color-light);
  border-radius: 8px;
}

.comment-input {
  margin-bottom: 10px;
}

.comment-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}

.comments-list {
  margin-top: 15px;
}

.comment-item {
  padding: 10px 0;
  border-bottom: 1px solid var(--el-border-color-light);
}

.comment-item:last-child {
  border-bottom: none;
}

.comment-content {
  flex: 1;
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 4px;
  gap: 8px;
}

.comment-info {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.comment-author {
  font-weight: 500;
  color: var(--el-text-color-primary);
  white-space: nowrap;
}

.comment-text {
  margin: 0;
  color: var(--el-text-color-regular);
  line-height: 1.4;
  flex: 1;
}

.comment-actions {
  display: flex;
  gap: 8px;
  white-space: nowrap;
}

.reply-info {
  font-size: 12px;
  color: var(--el-text-color-secondary);
  margin-top: 4px;
}

.delete-btn {
  color: var(--el-color-danger);
}

.delete-btn:hover {
  color: var(--el-color-danger-light-3);
}

.like-button-content {
  display: flex;
  align-items: center;
  gap: 5px;
}

.likes-list {
  margin-top: 10px;
  padding: 10px;
  background-color: var(--el-fill-color-light);
  border-radius: 8px;
}

.likes-header {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 5px;
  color: var(--el-text-color-secondary);
  font-size: 14px;
}

.likes-content {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.liker-name {
  color: var(--el-color-primary);
  font-size: 14px;
  cursor: pointer;
}

.liker-name:hover {
  text-decoration: underline;
}

.login-prompt {
  text-align: center;
  padding: 20px;
  color: var(--el-text-color-secondary);
}

.login-prompt p {
  margin-bottom: 10px;
}

.create-moment {
  margin-bottom: 10px;
}
</style> 